import React from 'react';

// Update this as new document types are added.
// [Maintainer]: Please keep the list sorted alphabetically with the exception of "other" which always should be last.
export const docTypes = [
  {
    name: 'bank_interest_report',
    description: 'report detailing bank interest information',
  },
  {
    name: 'bank_summary_report',
    description: 'a summary report of bank account activity',
  },
  {
    name: 'bank_transaction_report',
    description: 'a report containing bank transaction details',
  },
  {
    name: 'check_attachment',
    description:
      'an attachment to a mailed check.  PDFs, HTML, PNGs, and JPGs are allowed as attachments. For PDFs, PNGs, and JPGs, all pages must be sized at 8.5"x11" at 300 DPI. If HTML is supplied, it will be rendered and trimmed to fit as many 8.5"x11" pages as necessary. If a PDF is provided, it must be 6 pages or fewer. The attachment will be printed double-sided in black and white and included in the envelope after the check page. The ID can be used as `attachment_document_id` in the check issuing request.',
  },
  {
    name: 'daily_loan_tape',
    description: 'daily report of loan activities',
  },
  {
    name: 'daily_originations_activity',
    description: 'daily report of loan originations',
  },
  {
    name: 'daily_statement',
    description: 'daily account statement',
  },
  {
    name: 'daily_transaction_activity',
    description: 'daily report of transaction activities',
  },
  {
    name: 'dda_agreement',
    description: 'a demand deposit account agreement',
  },
  {
    name: 'identity_license',
    description:
      'a document to verify the identity of an account owner (e.g., driver licenses, state ID cards, Articles of Incorporation, etc.)',
  },
  {
    name: 'identity_passport',
    description: 'the passport of an account owner to verify the identity',
  },
  {
    name: 'identity_utility',
    description: 'an utility bill of an account owner',
  },
  {
    name: 'irs_letter',
    description: 'correspondence from the IRS',
  },
  {
    name: 'monthly_applications',
    description: 'monthly report of applications',
  },
  {
    name: 'monthly_loan_reporting',
    description: 'monthly report of loan activities',
  },
  {
    name: 'monthly_statement',
    description: 'monthly account statement',
  },
  {
    name: 'network_settlement_file',
    description: 'file containing network settlement information',
  },
  {
    name: 'receivable_purchases',
    description: 'documentation of receivable purchases',
  },
  {
    name: 'w9',
    description: 'IRS Form W-9 for tax identification',
  },
  {
    name: 'other',
    description: 'any other type of document not covered by the above categories',
  },
];

export const InlineAvailableDocTypes = () => {
  return (
    <>
      <span>Can be one of </span>{' '}
      {docTypes.map((docType, index) => (
        <span key={docType.name}>
          {index === docTypes.length - 1 && docTypes.length > 1 ? 'or ' : ''}
          <code>{docType.name}</code>
          {index < docTypes.length - 2 ? ', ' : ''}
          {index === docTypes.length - 2 ? ' ' : ''}
        </span>
      ))}
      .
    </>
  );
};

export const ListedAvailableDocTypesWithDescriptions = () => {
  return (
    <ul>
      {docTypes.map((docType) => (
        <li key={docType.name}>
          <code>{docType.name}</code>: {docType.description}
        </li>
      ))}
    </ul>
  );
};
